import styled, { css } from "styled-components";
import { fillWidth, heightUp } from "components/ui/animations";

export const AlertElement = styled.div`
    position: fixed;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    width: 100%;
    max-width: 300px;
    box-shadow: 0px 0px 12px -6px rgba(24, 39, 75, 0.12),
        0px 0 24px -4px rgba(24, 39, 75, 0.08);
    background: white;
    overflow: hidden;
    animation: ${css`
        ${heightUp} 0.4s cubic-bezier(0.13, 0.18, 0.4, 1.37) forwards
    `};
    font-size: 0.875rem;
    color: black;
    z-index: 2;
    font-weight: 500;
`;

export const AlertWrapper = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 0.9375rem;
    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 4px;
        width: 100%;
        background: #00a1ff;
        width: 0;
        animation: ${css`
            ${fillWidth} 4s ease forwards 4s
        `};
    }

    svg {
        path {
            fill: #09a509;
        }
        margin-right: 0.875rem;
    }

    p {
        margin: 0;
    }
`;
